import { dashboardRouter } from '@/routes/dashboardRouter';

export const router = () => dashboardRouter;
